import React, { useState } from "react";
import { Link as RouterLink, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, TextField, Button, Typography, Link, Stack, Alert } from "@mui/material";
import AuthApi from "../api/AuthApi";

const card = { p: { xs: 3, sm: 4 }, borderRadius: "var(--radius-lg)", bgcolor: "var(--surface)", border: "1px solid var(--border)", boxShadow: "var(--shadow-sm)" } as const;

/** Set a new password with the token from the reset e-mail (?token=...). */
export default function ResetPassword() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setError(""); setBusy(true);
    try {
      await AuthApi.passwordResetConfirm(token, password);
      setDone(true);
    } catch {
      setError(t("auth.resetError"));
    }
    setBusy(false);
  };

  return (
    <Container maxWidth="xs" sx={{ py: { xs: 6, sm: 10 } }}>
      <Box sx={card}>
        <Typography variant="h2" sx={{ fontSize: "1.4rem", mb: 1 }}>{t("auth.resetTitle")}</Typography>
        {done ? (
          <Stack spacing={2}>
            <Alert severity="success">{t("auth.resetSuccess")}</Alert>
            <Button component={RouterLink} to="/inloggen" variant="contained" size="large">{t("auth.submitLogin")}</Button>
          </Stack>
        ) : !token ? (
          <Alert severity="error">{t("auth.resetError")}</Alert>
        ) : (
          <>
            <Typography sx={{ color: "text.secondary", mb: 2.5 }}>{t("auth.resetBody")}</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            <Stack spacing={2} component="form" onSubmit={(e) => { e.preventDefault(); submit(); }}>
              <TextField label={t("auth.newPassword")} type="password" value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                helperText={t("auth.passwordHint")} autoFocus fullWidth required />
              <Button type="submit" variant="contained" size="large" disabled={busy || password.length < 8}>
                {busy ? t("funnel.submitting") : t("auth.resetSubmit")}
              </Button>
            </Stack>
          </>
        )}
        {!done && (
          <Typography sx={{ mt: 2, fontSize: ".9rem", color: "text.secondary" }}>
            <Link component={RouterLink} to="/wachtwoord-vergeten">{t("auth.forgotTitle")}</Link>
          </Typography>
        )}
      </Box>
    </Container>
  );
}
